module.exports = __webpack_public_path__ + "9e6364fbc4873ec734c7d8b99da6035f.svg";